import { isEmpty } from 'lodash';

const getBrandResponse = (response) => {
  if (isEmpty(response?.data?.brands)) return [];

  const brands = response.data.brands.map((brand) => {
    return {
      id: brand?.id,
      value: brand?.name,
      label: brand?.name,
    };
  });

  const sortedBrands = brands.sort((a, b) => a.label.localeCompare(b.label));

  return sortedBrands;
};

export default getBrandResponse;
